import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-foreground-400 mb-2">
              Product
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl italic text-foreground-950">
              Categories
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg leading-relaxed">
            Browse our organized Superbuy spreadsheet categories. Each category links directly to
            curated product collections on our main platform, updated regularly with the latest finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Superbuy Spreadsheet ${cat.name} category`}
                  title={`Superbuy Spreadsheet ${cat.name} - Browse curated products`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-800 text-xs font-medium rounded-full mb-2">
                  {cat.name}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200">
                  Superbuy {cat.name} Spreadsheet
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-1.5 leading-relaxed">
                  Explore curated {cat.name.toLowerCase()} collections with updated finds, QC
                  photos and organized product data.
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs font-medium text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Browse Collection
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}